<vdr-dropdown #dropdown>
  <button class="alerts-button" vdrDropdownTrigger>
    <div class="user-circle">
      <clr-icon
        shape="bell"
        class="is-solid"
        [ngClass]="{ 'has-badge': ((totalUnread$ | async) ?? 0) > 0 }"
        size="16"
      ></clr-icon>
    </div>
  </button>
  <vdr-dropdown-menu vdrPosition="bottom-right">
    <ng-container>
      <div class="alerts-panel p-0">
        <div
          class="flex items-center justify-between px-2 pb-2 pt-1 border-b border-gray-200"
        >
          <div class="flex items-center gap-1">
            <h4 class="font-medium m-0">Thông báo</h4>
            <div
              class="cursor-pointer"
              *ngIf="((totalUnread$ | async) ?? 0) > 0"
              (click)="readAllNotifications()"
            >
              <clr-icon shape="checkbox-list" size="20"></clr-icon>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <a
              [routerLink]="['notification']"
              class="text-[var(--color-primary-600)] hover:underline text-[12px] cursor-pointer"
              (click)="dropdown.toggleOpen()"
            >
              Xem tất cả
            </a>
          </div>
        </div>

        <div class="flex flex-wrap gap-2 p-2">
          <button
            class="px-1 py-0.5 rounded"
            [class.bg-[var(--color-primary-300)]]="
              selectedFilterType === NotifyType.BOOKING
            "
            [class.text-white]="selectedFilterType === NotifyType.BOOKING"
            [class.bg-gray-100]="selectedFilterType !== NotifyType.BOOKING"
            [class.text-gray-400]="selectedFilterType !== NotifyType.BOOKING"
            (click)="updateSelectedFilterType(NotifyType.BOOKING)"
          >
            Đặt phòng
          </button>
          <button
            class="px-1 py-0.5 rounded"
            [class.bg-[var(--color-primary-300)]]="
              selectedFilterType === NotifyType.RECONCILIATION_PERIOD
            "
            [class.text-white]="
              selectedFilterType === NotifyType.RECONCILIATION_PERIOD
            "
            [class.bg-gray-100]="
              selectedFilterType !== NotifyType.RECONCILIATION_PERIOD
            "
            [class.text-gray-400]="
              selectedFilterType !== NotifyType.RECONCILIATION_PERIOD
            "
            (click)="updateSelectedFilterType(NotifyType.RECONCILIATION_PERIOD)"
          >
            Đối soát và thanh toán
          </button>
          <button
            class="px-1 py-0.5 rounded"
            [class.bg-[var(--color-primary-300)]]="
              selectedFilterType === NotifyType.OTHER
            "
            [class.text-white]="selectedFilterType === NotifyType.OTHER"
            [class.bg-gray-100]="selectedFilterType !== NotifyType.OTHER"
            [class.text-gray-400]="selectedFilterType !== NotifyType.OTHER"
            (click)="updateSelectedFilterType(NotifyType.OTHER)"
          >
            Thông báo khác
          </button>
        </div>

        <div
          class="flex flex-col gap-2 px-2 pb-2 overflow-y-auto max-h-[400px]"
        >
          <ng-container *ngIf="loading$ | async; else notificationsContent">
            <div class="flex flex-col gap-2">
              <div
                *ngFor="let item of [1, 2, 3, 4, 5]"
                class="flex gap-2 rounded-lg p-1.5 items-start bg-gray-100 animate-pulse"
              >
                <div
                  class="w-6 h-6 bg-gray-300 rounded-full flex-shrink-0"
                ></div>

                <div class="flex-1 min-w-0">
                  <div class="flex items-start justify-between gap-2">
                    <div class="h-4 bg-gray-300 rounded flex-1"></div>
                    <div
                      class="w-16 h-3 bg-gray-300 rounded flex-shrink-0"
                    ></div>
                  </div>
                  <div class="mt-1 space-y-1">
                    <div class="h-3 bg-gray-300 rounded w-full"></div>
                    <div class="h-3 bg-gray-300 rounded w-3/4"></div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-template #notificationsContent>
            <ng-container
              *ngIf="
                (filteredNotifications$ | async)?.length;
                else noNotifications
              "
            >
              <div
                *ngFor="let notification of filteredNotifications$ | async"
                class="flex gap-2 rounded-lg p-1.5 items-start bg-gray-100 cursor-pointer hover:bg-gray-200 transition-colors"
                (click)="handleNotificationClick(notification)"
                [class.opacity-60]="notification.isRead"
              >
                <vdr-notification-icon
                  [severity]="getNotificationSeverity(notification)"
                  size="md"
                ></vdr-notification-icon>

                <div class="flex-1 min-w-0">
                  <div class="flex items-start justify-between gap-2">
                    <span
                      class="font-medium text-gray-800 break-words whitespace-pre-line"
                      >{{ notification.title }}</span
                    >
                    <span
                      class="text-gray-400 whitespace-nowrap text-[12px] flex-shrink-0"
                    >
                      {{ formatTimestamp(notification.createdAt) }}
                    </span>
                  </div>

                  <div
                    class="text-gray-600 mt-0.5 text-[12px] break-words whitespace-pre-line"
                  >
                    {{ notification.body }}
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-template>
        </div>

        <ng-template #noNotifications>
          <div class="flex items-center justify-center gap-1 p-4 text-gray-500">
            <clr-icon shape="info" />
            <span>Chưa có thông báo mới</span>
          </div>
        </ng-template>
      </div>
    </ng-container>
  </vdr-dropdown-menu>
</vdr-dropdown>
